/* eslint-disable no-unused-expressions */
import { useEffect } from "react";
import { useListState } from "@mantine/hooks";
import { format } from "date-fns";
import { useObjectives } from "../useAPI";
import useCloseObjectiveStore from "../../stores/useCloseObjectiveStore";

const useObjectivesList = () => {
  const [{ data, loading: isFetching }, fetchLatest] = useObjectives("closableObjectives", {
    manual: true,
  });

  const [values, handlers] = useListState();
  const updateToggle = useCloseObjectiveStore((state) => state.updateToggle);

  const content = {
    noDataMsg: `You have no objectives that can be closed`,
  };

  const getFormattedItems = () => {
    const formattedItems = [];
    data?.map((item) => {
      return formattedItems.push({
        label: item.name,
        checked: false,
        id: item._id,
        status: item.status,
        dueDate: format(new Date(item.dueDate), "dd/MM/yyyy"),
      });
    });
    return formattedItems;
  };

  useEffect(() => {
    if (!isFetching) {
      handlers.setState([...getFormattedItems()]);
    }
  }, [data, isFetching]);

  useEffect(() => {
    fetchLatest();
  }, [updateToggle]);

  const allItemsChecked = !isFetching && values?.every((value) => value.checked);
  const selectedValues = !isFetching && values?.filter((value) => (value.checked ? value : null));

  const selectAll = () => {
    handlers.setState((current) =>
      current.map((value) => ({ ...value, checked: !allItemsChecked }))
    );
  };

  const toggleItem = (event, index) => {
    handlers.setItemProp(index, "checked", event.currentTarget.checked);
  };

  return {
    values,
    isFetching,
    allItemsChecked,
    selectedValues,
    selectAll,
    toggleItem,
    content,
    fetchLatest,
  };
};

export default useObjectivesList;
